const state = { // 设置状态
    nowRoute:"",
    headerMargin: true,
    activeData:{}

}

const mutations = { // 同步计算
    SET_nowRoute: (state, v) => {
        state.nowRoute = v;
    },
  
    SET_headerMargin: (state, token) => {
      // 令牌
      state.headerMargin = token
    },
    SET_activeData: (state, v) => {
        state.activeData = v;
    },

}

const actions = {
    setNowRoute: ({commit}, v) => {
        commit('SET_nowRoute', v);
    },
    setHeaderMargin: ({commit}, v) => {
        commit('SET_headerMargin', v);
    },
    setActiveData: ({commit}, v) => {
        commit('SET_activeData', v);
    },
    loadActiveData({ commit }) {
        const savedData = sessionStorage.getItem('activeData');
        if (savedData) {
          commit('SET_activeData', JSON.parse(savedData));
        }
      }
}

export default {
  namespaced: true, // 开启命名空间防止变量重复
  state,
  mutations,
  actions
}